import { IDeliveryType } from "../models/configuration/plugin/IConfiguration";
import { SpecialDeliveryTypes, FullfillmentShippingOptions, SpecialClosingTypes } from "../enums/SpecialDeliveryTypes";
import { SECONDARY_CAPTIONS } from "./constants";

// Static list of required delivery types
export const REQUIRED_DELIVERY_TYPES = [
    { Id: "Collaboration" },
    { Id: "eClose" },
    { Id: "eDisclose" },
    { Id: "eMail" },
    { Id: "eSign" },
    { Id: "Mail" },
    { Id: "TexalLegalReview" }
];

// Helper: Add delivery type if missing
function addIfMissing(result: IDeliveryType[], id: string, caption: string) {
    if (!result.some(dt => dt.Id === id)) {
        result.push({
            Id: id,
            Caption: caption,
            Order: null,
            ToolTipText: "",
            AutoSelectWhen: "",
            Enabled: false,
            Expressions: [],
            Roles: [],
            Users: [],
            CustomAttributes: {
                IPENVendor: null,
                IframeVendor: null,
                VerificationVendorType: null,
                FormFreeLenderID: null,
                SolexDocEditorAttr: false
            },
            EnableForTpoUser: false
        });
    }
}

// Helper: Add multiple delivery types
function addMultipleIfMissing(result: IDeliveryType[], types: Array<{ id: string, caption: string }>) {
    types.forEach(type => addIfMissing(result, type.id, type.caption));
}

// Ensure all required delivery types are present
export function ensureRequiredDeliveryTypes(deliveryTypes: IDeliveryType[] = []): IDeliveryType[] {
    let result = [...deliveryTypes];
    REQUIRED_DELIVERY_TYPES.forEach(required => {
        addIfMissing(result, required.Id, "");
    });
    return result;
}

// Ensure all special delivery types are present
export function ensureSpecialDeliveryTypes(deliveryTypes: IDeliveryType[] = []): IDeliveryType[] {
    let result = [...deliveryTypes];

    // Print In Person
    addIfMissing(result, SpecialDeliveryTypes.PrintInPerson, "Print In Person");

    // FullfillmentShippingOptions (Mail-*)
    addMultipleIfMissing(
        result,
        Object.entries(FullfillmentShippingOptions).map(([key, value]) => ({
            id: `Mail-${key}`,
            caption: `Mail-${value}`
        }))
    );

    // SpecialClosingTypes (eClose-*)
    addMultipleIfMissing(
        result,
        Object.entries(SpecialClosingTypes).map(([key, value]) => ({
            id: `eClose-${key}`,
            caption: `eClose-${value}`
        }))
    );

    // Secondary types
    const secondaryTypes = [
        { id: SpecialDeliveryTypes.ESignSecondaryId, caption: SECONDARY_CAPTIONS.ESign },
        { id: SpecialDeliveryTypes.EDsicloseSecondaryId, caption: SECONDARY_CAPTIONS.EDisclose },
        { id: SpecialDeliveryTypes.ECloseSecondaryId, caption: SECONDARY_CAPTIONS.EClose }
    ];
    addMultipleIfMissing(result, secondaryTypes);

    return result;
}
